const readmeContent = `

### Notice
Please note that any use of the following logs must comply with FERPA regulations.
If you plan to use these logs for research, anonymize them or request student consent.

### Reasons for data naming
In order to keep file sizes as small as possible, field names have been obfuscated as much as possible to limit byte storage.
The following API specifies exactly what each field represents and its value type(s).

### Data API
s => [s]tartSession: str (str => ISO timestamp)\n
e => [e]ndSession\*: str (str => ISO timestamp)\n
f => [f]ocusChanges: int\n
c => [c]harsTyped: int\n
b => [b]ackspaces: int\n
p => [p]asteEvents: int\n
m => [m]ouseClicks: int\n
x => cursorMoves: int\n
u => [u]uid: str (uuid of the Lambda question)\n
t => [t]ype: str (L => [L]ambda, P => [P]rogramming, S => [S]ession)\n
r => [r]esults: str | array (str => error, array => failed test identifier(s): str)\n

\*For the Lambda and the Programming log types, the \`e\` field represents when results from the GoValuate autograders finished and were available to students.

`


export default readmeContent;